export const pathwayAction_isOrder = (action) => {
    return action?.type === 'order';
};
export const pathwayAction_isInterflow = (action) => {
    return action?.type === 'interflow';
};
//# sourceMappingURL=utils.js.map